import { createContext, useContext } from 'react';
import { useEpisodesController } from '@controllers/useEpisodesController';

const EpisodesContext = createContext(null);

export function EpisodesProvider({ children }) {
  const value = useEpisodesController();

  return (
    <EpisodesContext.Provider value={value}>
      {children}
    </EpisodesContext.Provider>
  );
}

export function useEpisodes() {
  const context = useContext(EpisodesContext);
  if (!context) {
    throw new Error('useEpisodes must be used within EpisodesProvider');
  }
  return context;
}
